import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Sidebar from "./Components/Sidebar";
import Home from "./Components/Home";
import AddCategory from "./Components/Category/AddCategory";
import AddBrand from "./Components/Brand/AddBrand";
import AddProduct from "./Components/Products/AddProduct";
import  Profile  from "./Components/Profile";
import AdminContact from "./AdminContact";
import AdminLogin from "./AdminLogin";
import OrderRequest from "./Components/OrderRequest/OrderRequest";

function App() {
  return<>
     <BrowserRouter>
       <Navbar/>
       <Sidebar/>

       <Routes>
       <Route path="/" element={<Home/>}></Route>
       <Route path="/addCategory" element={<AddCategory/>}></Route> 
       <Route path="/addBrand" element={<AddBrand/>}></Route> 
       <Route path="/addProduct" element={<AddProduct/>}></Route> 
       <Route path="/OrderRequest" element={<OrderRequest/>}></Route> 
       <Route path="/Profile" element={<Profile/>}></Route> 
       <Route path="/AdminContact" element={<AdminContact/>}></Route> 
       <Route path="/AdminLogin" element={<AdminLogin/>}></Route> 
       </Routes>
     </BrowserRouter>
  </>
}

export default App;
